import script from "./SudokuCell.vue?vue&type=script&setup=true&lang=js"
export * from "./SudokuCell.vue?vue&type=script&setup=true&lang=js"

import "./SudokuCell.vue?vue&type=style&index=0&id=8f2b887e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f2b887e"]])

export default __exports__